module.exports = __webpack_public_path__ + "media/images/ic-quote-right-b3c33582abf798c038fff02bc7d71b20.svg";